import { XClose } from '@aktiia/design-system';
import { format } from 'date-fns';
import { MouseEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BpType } from '../../../../../enums';
import { parseDate } from '../../../../../utils';
import { BpStatusButton } from '../button';
import { IBpStatusPopoverProps } from './types';

export const BpStatusPopover = ({ patient, isUS, onClose }: IBpStatusPopoverProps) => {
  const { t } = useTranslation();
  const { status } = patient.bloodPressure;
  const measurements = useMemo(() => {
    return [...patient.bloodPressure.measurements].reverse();
  }, [patient.bloodPressure.measurements]);

  const content = useMemo(() => {
    if (status.toLowerCase() === BpType.PENDING.toLowerCase()) {
      return <p className="typography-paragraph-3 text-text-secondary">{t('patients.bpType.unavailable')}</p>;
    } else {
      const syncDate = format(parseDate(measurements[0].date), 'd MMM yyyy');

      return (
        <>
          <p className="typography-paragraph-3 text-text-secondary">{t('patients.bpType.available', { syncDate })}</p>
          <ul className="mt-4">
            {measurements.map((dayData, index) => (
              <li key={index} className="flex justify-between content-center mt-2 first:mt-0">
                <span className="typography-title-3 text-text-secondary">
                  {format(parseDate(dayData.date), 'd MMM')}
                </span>
                <span className="typography-heading-6 text-text-primary">
                  {dayData.sys && dayData.dia ? `${dayData.sys}/${dayData.dia}` : '-'}
                </span>
              </li>
            ))}
          </ul>
        </>
      );
    }
  }, [status, measurements]);

  const handleInteralClick = (event: MouseEvent) => event.stopPropagation();

  return (
    <div
      className="w-[230px] bg-background-base-primary border border-border-light rounded-xl shadow-high"
      onClick={handleInteralClick}
    >
      <div className="flex items-center justify-between py-3 px-4 border-b border-border-divider">
        <BpStatusButton status={status} isUS={isUS} />
        <XClose className="cursor-pointer scale-75" onClick={onClose} />
      </div>

      <div className="py-3 px-4">{content}</div>
    </div>
  );
};
